// extracted by mini-css-extract-plugin
export default {"footerText":"SibiFooter_footerText__jiV-m","sibiFooter":"SibiFooter_sibiFooter__NdaIU","footerPadding":"SibiFooter_footerPadding__DwA1+","navItem":"SibiFooter_navItem__kseGZ"};